// Creates a seeded pseudo random number generator where a given seed
// will produce the same "random" numbers.
// https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
const mulberry32 = function(a) {
	return function() {
		let t = (a += 0x6d2b79f5);
		t = Math.imul(t ^ (t >>> 15), t | 1);
		t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
};

// Converts hash to 32 bit int (easy to predict value, used for mulberry above).
// Do not use for sensitive information.
const hashStr = function(str) {
	let hash = 0,
		i,
		chr;
	if (str.length === 0) return hash;
	for (i = 0; i < str.length; i++) {
		chr = str.charCodeAt(i);
		hash = (hash << 5) - hash + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
};

// Gets pseudo random seeded generator
const pseudoRNG = function(str) {
	const hash = hashStr(str);
	return mulberry32(hash);
};

/**
 * Takes in a string and optional object containing min/max values.
 * This function returns a random integer that is generated through the mulberry32 function.
 * If max and min values are specified, those are taken into account, otherwise the random integer can be between 0 and the max number value in javascript
 */
const pseudoRandomInt = function(str, options = {}) {
	let {min = 0, max = Number.MAX_VALUE} = options;
	min = Math.floor(min);
	max = Math.floor(max);
	const baseRNG = pseudoRNG(str);
	return () => Math.floor(baseRNG() * (max - min) + min);
};

module.exports = {
	pseudoRNG,
	pseudoRandomInt,
};
